import { useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import SchedulePage from "@/pages/SchedulePage";
import MenuPage from "@/pages/MenuPage";
import SeasonalPage from "@/pages/SeasonalPage";
import EventsPage from "@/pages/EventsPage";
import RewardsPage from "@/pages/RewardsPage";
import AboutPage from "@/pages/AboutPage";
import GalleryPage from "@/pages/GalleryPage";
import CommunityPage from "@/pages/CommunityPage";
import FlavorFantasiaPage from "@/pages/FlavorFantasiaPage";
import LoginPage from "@/pages/LoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLocations from "@/pages/admin/AdminLocations";
import AdminMenu from "@/pages/admin/AdminMenu";
import AdminSeasonal from "@/pages/admin/AdminSeasonal";
import AdminPhotos from "@/pages/admin/AdminPhotos";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminCommunity from "@/pages/admin/AdminCommunity";
import AdminFlavors from "@/pages/admin/AdminFlavors";
import AdminHomepage from "@/pages/admin/AdminHomepage";
import AdminLoyalty from "@/pages/admin/AdminLoyalty";
import AuthCallback from "@/pages/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment synchronously during render (NOT in useEffect)
  // This prevents race conditions by processing session_id FIRST
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/schedule" element={<SchedulePage />} />
      <Route path="/menu" element={<MenuPage />} />
      <Route path="/seasonal" element={<SeasonalPage />} />
      <Route path="/events" element={<EventsPage />} />
      <Route path="/rewards" element={<RewardsPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/community" element={<CommunityPage />} />
      <Route path="/flavor-fantasia" element={<FlavorFantasiaPage />} />
      <Route path="/login" element={<LoginPage />} />
      
      {/* Admin Routes - Protected */}
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/locations" element={<ProtectedRoute><AdminLocations /></ProtectedRoute>} />
      <Route path="/admin/menu" element={<ProtectedRoute><AdminMenu /></ProtectedRoute>} />
      <Route path="/admin/seasonal" element={<ProtectedRoute><AdminSeasonal /></ProtectedRoute>} />
      <Route path="/admin/photos" element={<ProtectedRoute><AdminPhotos /></ProtectedRoute>} />
      <Route path="/admin/bookings" element={<ProtectedRoute><AdminBookings /></ProtectedRoute>} />
      <Route path="/admin/community" element={<ProtectedRoute><AdminCommunity /></ProtectedRoute>} />
      <Route path="/admin/flavors" element={<ProtectedRoute><AdminFlavors /></ProtectedRoute>} />
      <Route path="/admin/homepage" element={<ProtectedRoute><AdminHomepage /></ProtectedRoute>} />
      <Route path="/admin/loyalty" element={<ProtectedRoute><AdminLoyalty /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
